import cn from 'classnames';
import { Label } from '@dealroadshow/uikit/core/components/Badge/Label';
import { Tooltip } from '@dealroadshow/uikit/core/components/Tooltip';
import { IDealStatus } from '@/finsight/domain/vo/IDeal';

import styles from './dealStatus.scss';

const mapStatusToColor = {
  PRCD: '#4AB675',
  ANNC: '#5B97D7',
  ANCD: '#5B97D7',
  LNCH: '#5B97D7',
  GDNC: '#5B97D7',
  PMKT: '#5B97D7',
  MNDT: '#5B97D7',
  FILD: '#616161',
  '15-G': '#616161',
  RUMR: '#616161',
  PTPD: '#CC4D4D',
  CNCD: '#CC4D4D',
};

const mapStatusToClassName = {
  PRCD: styles.statusLabelBorderVar1,
  LNCH: styles.statusLabelBorderVar2,
  GDNC: styles.statusLabelBorderVar2,
  ANNC: styles.statusLabelBorderVar2,
  ANCD: styles.statusLabelBorderVar2,
  PMKT: styles.statusLabelBorderVar2,
  MNDT: styles.statusLabelBorderVar2,
  FILD: styles.statusLabelBorderVar3,
  '15-G': styles.statusLabelBorderVar3,
  RUMR: styles.statusLabelBorderVar3,
  PTPD: styles.statusLabelBorderVar4,
  CNCD: styles.statusLabelBorderVar4,
};

const DealStatus = ({ status }: { status: IDealStatus }) => (
  <div className={ styles.statusCell } data-test="dealRowStatus">
    { status ? (
      <Tooltip content={ status?.name }>
        <Label
          className={ cn(styles.statusLabel, styles.label, mapStatusToClassName[status.abbreviation]) }
          textColor={ mapStatusToColor[status.abbreviation] || '#8c8c8c' }
          backgroundColor="#fff"
        >
          { status?.abbreviation }
        </Label>
      </Tooltip>
    ) : null }
  </div>
);

export default DealStatus;
